import * as DTO from '@rw1/auto-generated-clients/generated/session-management/dto.generated'
import { injectable } from 'inversify'
import * as Models from '@rw1/models'
import { ISessionManagementMapper } from './ISessionManagementMapper'

@injectable()
export class SessionManagementMapper implements ISessionManagementMapper {
    toMultiplayerSessionModel(dto: DTO.MultiplayerSession, room: Models.Room | undefined): Models.MultiplayerSession {
        return {
            multiplayerSessionId: dto.multiplayerSessionId,
            creationDate: dto.creationDate,
            visibility: this.toVisibility(dto.visibility),
            isRecordingReplay: dto.isRecordingReplay,
            currentPlayers: dto.currentPlayers,
            serverEndpoint: dto.serverEndpoint,
            creatorUserId: dto.creatorUserId,
            roomMetadataId: dto.roomMetadataId,
            contentVersion: dto.contentVersion,
            title: dto.title,
            replayId: dto.replayId,
            mapName: room?.mapPath,
            companyContentGuid: room?.contentMetadataId ?? '',
            companyContentTag: room?.tagName,
            maxPlayers: room?.maxUsers,
            region: dto.region
        }
    }

    toMultiplayerSessionModelFromMultiplayerSessionWithoutId(dto: DTO.MultiplayerSessionWithoutId): Models.MultiplayerSession {
        return {
            multiplayerSessionId: undefined,
            creationDate: undefined,
            visibility: this.toVisibility(dto.visibility),
            isRecordingReplay: false,
            currentPlayers: 0,
            serverEndpoint: undefined,
            creatorUserId: undefined,
            roomMetadataId: dto.roomMetadataId,
            contentVersion: undefined,
            title: dto.title,
            replayId: dto.replayId
        }
    }

    toVisibility(dto: DTO.VisibilityType | null | undefined): Models.Visibility {
        if (!dto) {
            return Models.Visibility.Private
        }
        switch (dto) {
            case DTO.VisibilityType.Public:
                return Models.Visibility.Public
            case DTO.VisibilityType.Internal:
                return Models.Visibility.Internal
            case DTO.VisibilityType.Private:
                return Models.Visibility.Private
            default:
                throw new Error(`Unknown visibility type: ${dto}`)
        }
    }

    ToVisibilityFromString(visibility: string): Models.Visibility {
        switch (visibility) {
            case 'Public':
                return Models.Visibility.Public
            case 'Internal':
                return Models.Visibility.Internal
            case 'Private':
            default:
                return Models.Visibility.Private
        }
    }

    toDtoVisibilityType(model: Models.Visibility | undefined): DTO.VisibilityType {
        switch (model) {
            case Models.Visibility.Public:
                return DTO.VisibilityType.Public
            case Models.Visibility.Internal:
                return DTO.VisibilityType.Internal
            case Models.Visibility.Private:
                return DTO.VisibilityType.Private
            default:
                throw new Error(`Unknown visibility type: ${model}`)
        }
    }

    toMultiplayerSessionWithoutId(
        title: string,
        roomMetadataId: string,
        visibility: Models.Visibility,
        replayId?: string): DTO.MultiplayerSessionWithoutId {
        return {
            title: title,
            roomMetadataId: roomMetadataId,
            visibility: this.toDtoVisibilityType(visibility),
            replayId: replayId
        } as DTO.MultiplayerSessionWithoutId
    }
}